
import { financeCurrencysOption } from "@/utils/options";


export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '国家店铺',
    prop: 'countryMarketValue',
    components: [{
        name: 'gj-country-server-select',
        prop: 'countryMarketValue'
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: {
        countryIds: [],
        marketIds: []
    }
}, {
    label: '币种',
    prop: 'currency',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'currency',
        propsData: {
            options: financeCurrencysOption,
            placeholder: '币种'
        }
    }],
    defaultValue: ''
},  {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    slot: 'dateRange',
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}, {
    prop: 'dateType',
    defaultValue: 'DAY'
}, {
    label: '负责人',
    labelWidth: '120px',
    prop: 'sellingManagerIds',
    isFormItem: true,
    components: [{
        name: 'gj-charger-select',
        prop: 'sellingManagerIds',
        propsData: {
            placeholder: '全部负责人',
            collapseTags: true
        }
    }],
    defaultValue: []
}, {
    label: '品类',
    labelWidth: '120px',
    prop: 'categoryIds',
    isFormItem: true,
    components: [{
        name: 'gj-category-select',
        prop: 'categoryIds',
        propsData: {
            placeholder: '品类',
            multiple: true,
            collapseTags: true
        }
    }],
    defaultValue: []
}, {
    label: '品牌',
    labelWidth: '120px',
    prop: 'brandId',
    isFormItem: true,
    components: [{
        name: 'gj-brand-select',
        prop: 'brandId',
        propsData: {
            placeholder: '品牌',
            active: true
        }
    }],
    defaultValue: ''
}]
